import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Box from "@material-ui/core/Box";
import BackdropLoading from "../../components/BackdropLoading";
import Container from "@material-ui/core/Container";
import React from "react";
import Skeleton from "@material-ui/lab/Skeleton";

function TicketReservationSkeleton() {
  return (
    <>
      <Box mb={3}>
        <AppBar color="inherit">
          <Toolbar>
            <Skeleton width="100%" height={30} />
          </Toolbar>
        </AppBar>
        <Toolbar style={{ marginTop: "env(safe-area-inset-top)" }} />
      </Box>
      <Container maxWidth="sm">
        <BackdropLoading />
      </Container>
    </>
  );
}

export default TicketReservationSkeleton;
